export interface VelocityRow {
  symbol: string;
  composite?: number | null;
  q?: number | null;
  v?: number | null;
  d5?: { dcomp?: number | null } | null;
  d20?: { dcomp?: number | null } | null;
  alphaStreak?: number | null;
}

export interface TargetPriceRow {
  symbol: string;
  fiveYearTarget?: number | null;
  asymmetry?: number | null;
  currentPrice?: number | null;
  analystTarget?: number | null;
  analystRating?: number | null;
  analystCount?: number | null;
}

export interface HedgeSignal {
  asymZ?: number;
  mom12?: number;
}

export interface PillarScores {
  profitability?: number | null;
  growth?: number | null;
  safety?: number | null;
  shareholderReturns?: number | null;
  momentum?: number | null;
}

export interface Stock {
  symbol: string;
  name?: string | null;
  sector?: string | null;
  price?: number | null;
  composite?: number | null;
  q?: number | null;
  v?: number | null;
  qualityScore?: number | null;
  /** Production blended Q = 0.75·peer-z + 0.25·universe-z absolute. */
  qualityScoreBlended?: number | null;
  valuationScore?: number | null;
  /** Production blended V = 0.75·peer-z + 0.25·universe-z absolute. */
  valuationScoreBlended?: number | null;
  compositeScore?: number | null;
  pillarScores?: PillarScores | null;
  factors?: Record<string, number | null> | null;
}

export interface SelfPctileAxis {
  current?: number | null;
  percentile?: number | null;
  regime?: string | null;
  count?: number | null;
}

export interface SelfPctileEntry {
  q?: SelfPctileAxis;
  v?: SelfPctileAxis;
  composite?: SelfPctileAxis;
}

export const fmtZ = (v: number | null | undefined, digits = 2): string => {
  if (v == null || !Number.isFinite(v)) return '—';
  const sign = v >= 0 ? '+' : '';
  return `${sign}${v.toFixed(digits)}`;
};

export const fmtPctile = (v: number | null | undefined): string => {
  if (v == null || !Number.isFinite(v)) return '—';
  return `${v.toFixed(0)}%`;
};
